export default "__VITE_ASSET__5kpdaQFo__"